/*
 * @Author: liyxt
 * @Date: 2019-10-21 14:15:59
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:54:43
 * @Description: file content
 */
import Notification from 'bee-notification';

require('bee-notification/build/Notification.css');

export default Notification;
